<template>
  <l-layout :layout="['xs12']">
    <v-card>
      <v-card-title style="height: 64px">
        <span class="title pl-2">{{group.name}}</span>
        <v-layout class="pl-4" wrap>
          <v-flex xs6>
            <span class="grey--text caption mr-2">创建时间</span>
            <span class="pr-4">{{$L.time.stringify(group.creationTime) || 'N/A'}}</span>
          </v-flex>
          <v-flex xs6>
            <span class="grey--text caption mr-2">上次更新</span>
            <span class="pr-4">{{$L.time.stringify(group.lastUpdateTime) || 'N/A'}}</span>
          </v-flex>
        </v-layout>
        <v-spacer></v-spacer>
        <slot name="title-actions"></slot>
        <v-btn @click="goEdit()" color="primary" flat small>编辑</v-btn>
        <v-btn @click="$emit('refresh')" color="primary" flat small>刷新</v-btn>
      </v-card-title>
      <v-card-text v-if="type==='org'">
        <v-tabs grow v-model="tab">
          <v-tab key="info">单位详情</v-tab>
          <v-tab key="manager" v-if="type!=='reservation'">单位管理员</v-tab>
          <v-tab key="vehicle" v-if="type!=='reservation'">公车管理</v-tab>
        </v-tabs>
        <v-divider></v-divider>
        <v-tabs-items v-model="tab">
          <v-tab-item key="info">
            <l-layout column class="pa-4" :layout="['xs12']">
              <v-container class="py-0" fluid grid-list-md>
                <v-card class="pa-2">
                <v-layout class="mb-4" wrap>
                  <v-flex xs12 sm6>
                    <v-text-field
                      :label="typeName + '名称'"
                      disabled
                      placeholder="N/A"
                      prepend-icon="$vuetify.icons.group"
                      v-model="group.name"
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs12 sm6>
                    <v-text-field
                      disabled
                      placeholder="N/A"
                      :label="'父级' + typeName"
                      prepend-icon="$vuetify.icons.groupParent"
                      v-model="group.parentName"
                    ></v-text-field>
                  </v-flex>
                  <v-flex sm4 xs6>
                    <v-text-field
                      :label="typeName + '级别'"
                      disabled
                      placeholder="N/A"
                      prepend-icon="$vuetify.icons.level"
                      v-model="group.codeLevel"
                    ></v-text-field>
                  </v-flex>
                  <v-flex sm4 xs6>
                    <v-text-field
                      :label="typeName + '代码'"
                      disabled
                      placeholder="N/A"
                      prepend-icon="$vuetify.icons.levelCode"
                      v-model="group.code"
                    ></v-text-field>
                  </v-flex>
                  <v-flex sm4 xs12>
                    <v-text-field
                      placeholder="N/A"
                      :label="'分组类型'"
                      v-model="group.type"
                      disabled
                      prepend-icon="$vuetify.icons.group"
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs12>
                    <v-textarea
                      :label="typeName + '描述'"
                      :rows="1"
                      auto-grow
                      disabled
                      placeholder="N/A"
                      prepend-icon="$vuetify.icons.description"
                      v-model="group.description"
                    ></v-textarea>
                  </v-flex>
                  <v-layout row  wrap>
                    <v-flex xs12>
                      <v-textarea
                        disabled
                        auto-grow
                        label="进场屏显提示词"
                        prepend-icon="$vuetify.icons.led"
                        rows="1"
                        v-model="group.osdMsgIn"
                      ></v-textarea>
                    </v-flex>
                    <v-flex xs12>
                      <v-textarea
                        disabled
                        auto-grow
                        label="进场语音提示词"
                        prepend-icon="$vuetify.icons.audio"
                        rows="1"
                        v-model="group.vcbMsgIn"
                      ></v-textarea>
                    </v-flex>
                    <v-flex xs12>
                      <v-textarea
                        disabled
                        auto-grow
                        label="出场屏显提示词"
                        prepend-icon="$vuetify.icons.led"
                        rows="1"
                        v-model="group.osdMsgOut"
                      ></v-textarea>
                    </v-flex>
                    <v-flex xs12>
                      <v-textarea
                        disabled
                        auto-grow
                        label="出场语音提示词"
                        prepend-icon="$vuetify.icons.audio"
                        rows="1"
                        v-model="group.vcbMsgOut"
                      ></v-textarea>
                    </v-flex>
                  </v-layout>
                </v-layout>
                </v-card>
        <!--        <v-card class="pa-2 mt-4">
                <v-subheader>绑定角色</v-subheader>
                <v-layout class="mb-4" wrap>
                  <v-flex xs12>
                    <l-data-table
                      :headers="roleHeaders"
                      :items="group.roleList"
                      auto-actions
                      flat
                      hide-headers
                      hide-title
                      no-data-text="没有绑定角色"
                    ></l-data-table>
                  </v-flex>
                </v-layout>
                </v-card>-->
              </v-container>
              <v-card class="pa-2 ma-4">
              <v-expand-transition>
                <v-container class="pt-0" fluid grid-list-md v-if="showUser">
                  <v-subheader>绑定用户</v-subheader>
                  <v-layout class="mb-4" wrap>
                    <v-flex xs12>
                      <l-data-table
                        :get-data-func="getBindUsers"
                        :get-data-payload="group"
                        :headers="userHeaders"
                        auto-actions
                        flat
                        hide-title
                        no-data-text="没有绑定用户"
                      ></l-data-table>
                    </v-flex>
                  </v-layout>
                </v-container>
              </v-expand-transition>
              <v-layout>
                <v-flex class="text-xs-center">
                  <v-btn @click="showUser = !showUser" color="primary" flat>{{showUser ? '收起':'显示'}}已绑定用户</v-btn>
                </v-flex>
              </v-layout>
              </v-card>
            </l-layout>
          </v-tab-item>
          <v-tab-item key="manager">
            <l-data-table
              :headers="extraInfo.adminHeader"
              :items="extraInfo.adminSelect"
              hide-title-search
              hide-refresh
              title-text="单位管理员列表">
              <template slot="row-action" slot-scope="{item}">
                <v-btn icon @click="deleteAdminConfirm(item)">
                  <v-icon>$vuetify.icons.delete</v-icon>
                </v-btn>
              </template>
              <template slot="title">
                <span class="pl-2 pr-4">单位管理员列表</span>
                <v-btn color="primary" flat @click="addAdminInfo.activated = true">添加单位管理员</v-btn>
              </template>
            </l-data-table>
          </v-tab-item>
          <v-tab-item key="vehicle">
           <!-- <v-layout  class="mb-3">
              <v-flex xs2 class="mt-3">
                <v-btn flat color="primary" @click="addVehicle">添加</v-btn>
              </v-flex>
            </v-layout>-->
            <l-data-table
              :headers="extraInfo.vehicleHeader"
              :items="extraInfo.vehicleSelect"
              hide-title-search
              hide-refresh
              title-text="单位公车列表">
              <template slot="title">
                <span>单位公车列表</span>
                <v-btn flat color="primary" v-if="addVehicleInfo.referIdSlot!==''" @click="goToPassGroup">跳转通行分组</v-btn>
                <v-btn flat color="primary" @click="addVehicle">添加车辆</v-btn>
              </template>
              <template slot="row-action" slot-scope="{item}">
                <v-menu  left>
                  <v-btn slot="activator" icon small>
                    <v-icon  small>$vuetify.icons.more</v-icon>
                  </v-btn>
                  <v-list dense>
                    <v-list-tile @click="deleteVehicleConfirm(item)">
                      <v-list-tile-title class="pr-1">
                        删除车辆
                      </v-list-tile-title>
                    </v-list-tile>
                    <v-list-tile @click="editAddVehicle(item)">
                      <v-list-tile-title class="pr-1">
                        编辑车辆
                      </v-list-tile-title>
                    </v-list-tile>
                  </v-list>
                </v-menu>
              </template>
            </l-data-table>
          </v-tab-item>
        </v-tabs-items>
      </v-card-text>
      <v-card-text v-else>
        <v-container class="py-0" fluid grid-list-md>
          <v-card class="pa-2">
          <v-layout class="mb-4" wrap>
            <v-flex xs12 sm6>
              <v-text-field
                :label="typeName + '名称'"
                disabled
                placeholder="N/A"
                prepend-icon="$vuetify.icons.group"
                v-model="group.name"
              ></v-text-field>
            </v-flex>
            <v-flex xs12 sm6>
              <v-text-field
                disabled
                placeholder="N/A"
                :label="'父级' + typeName"
                prepend-icon="$vuetify.icons.groupParent"
                v-model="group.parentName"
              ></v-text-field>
            </v-flex>
            <v-flex sm4 xs6>
              <v-text-field
                :label="typeName + '级别'"
                disabled
                placeholder="N/A"
                prepend-icon="$vuetify.icons.level"
                v-model="group.level"
              ></v-text-field>
            </v-flex>
            <v-flex sm4 xs6>
              <v-text-field
                :label="typeName + '代码'"
                disabled
                placeholder="N/A"
                prepend-icon="$vuetify.icons.levelCode"
                v-model="group.code"
              ></v-text-field>
            </v-flex>
            <v-flex sm4 xs12>
              <v-text-field
                placeholder="N/A"
                :label="'分组类型'"
                v-model="group.type"
                disabled
                prepend-icon="$vuetify.icons.group"
              ></v-text-field>
            </v-flex>
            <v-flex xs12>
              <v-textarea
                :label="typeName + '描述'"
                :rows="1"
                auto-grow
                disabled
                placeholder="N/A"
                prepend-icon="$vuetify.icons.description"
                v-model="group.description"
              ></v-textarea>
            </v-flex>
          </v-layout>
          </v-card>
        </v-container>
        <v-card class="pa-2 ma-4">
        <v-expand-transition>
          <v-container class="pt-0" fluid grid-list-md v-if="showUser">
            <!--<v-subheader>绑定用户</v-subheader>-->
            <v-layout class="mb-4" wrap>
              <v-flex xs12>
                <l-data-table
                  :get-data-func="getBindUsers"
                  :get-data-payload="group"
                  :headers="userHeaders"
                  auto-actions
                  flat
                  hide-headers
                  title-text="绑定用户"
                  search-text="请输入工号查询"
                  no-data-text="没有绑定用户"
                ></l-data-table>
              </v-flex>
            </v-layout>
          </v-container>
        </v-expand-transition>
        <v-layout>
          <v-flex class="text-xs-center">
            <v-btn @click="showUser = !showUser" color="primary" flat>{{showUser ? '收起':'显示'}}已绑定用户</v-btn>
          </v-flex>
        </v-layout>
        </v-card>
        <v-card v-if="type==='reservationGroup'" class="pa-3 ma-4">
          <v-card-title>
            预约规则配置
          </v-card-title>
          <v-layout class="pa-2" column>
            <v-radio-group mandatory row v-model="reservationType" label="预约类型">
              <v-radio :value="'vehicle'" label="车行"></v-radio>
              <v-radio :value="'person'" label="人行"></v-radio>
            </v-radio-group>
            <v-layout>
              <v-flex xs6>
                <span>单位预约</span>
                <v-btn color="primary" flat v-if="hasOrgConfig" @click="goOrgConfig">跳转分组单位预约配置</v-btn>
                <v-btn color="primary" flat v-else @click="createOrgConfig">创建分组单位预约配置</v-btn>
              </v-flex>
            </v-layout>
            <v-layout>
              <v-flex xs6>
                <span>个人预约</span>
                <v-btn color="primary" flat v-if="hasPersonConfig" @click="goPersonConfig">跳转分组个人预约配置</v-btn>
                <v-btn color="primary" flat v-else @click="createPersonConfig">创建分组个人预约配置</v-btn>
              </v-flex>
            </v-layout>
          </v-layout>
        </v-card>
      </v-card-text>
    </v-card>
    <v-dialog scrollable persistent v-model="addVehicleInfo.activate" max-width="900px">
        <v-card>
          <v-card-title  style="height: 64px">
            <v-layout>
              <h3>添加车辆</h3>
            </v-layout>
            <v-spacer></v-spacer>
            <v-btn icon @click="addVehicleInfo.activate = false">
              <v-icon>{{$vuetify.icons.close}}</v-icon>
            </v-btn>
          </v-card-title>
          <v-divider></v-divider>
          <v-card-text>
          <v-form ref="addVehicleForm">
            <v-layout column>
              <v-flex class="pa-3">
                <v-switch v-model="addVehicleInfo.isCo" label="是否以合同方式录入"></v-switch>
              </v-flex>
              <v-subheader v-if="addVehicleInfo.isCo">合同信息</v-subheader>
              <v-flex xs4 sm4 v-if="addVehicleInfo.isCo" class="pl-3 pr-3">
                <v-text-field label="合同名称" prepend-icon="$vuetify.icons.title" v-model="addVehicleInfo.coName" :rules="[$rules.requiredS()]"></v-text-field>
              </v-flex>
              <v-layout column class="pl-4" v-if="addVehicleInfo.isCo">
                <v-flex xs12>
                  <l-image v-if="addVehicleInfo.coImage.length === 0"></l-image>
                  <l-image-dialog
                    :src="img.src"
                    v-for="(img,i) in addVehicleInfo.coImage" :key="i">
                    <l-image
                      slot="activator"
                      :src="img.src"
                      :error="img.error"
                      :errorMessage="img.errorMessage"
                    >
                      <template slot="action">
                        <v-tooltip bottom>
                          <span>删除图像</span>
                          <v-btn slot="activator" @click="deleteImage(addVehicleInfo.coImage, i)" icon>
                            <v-icon>$vuetify.icons.delete</v-icon>
                          </v-btn>
                        </v-tooltip>
                      </template>
                    </l-image>
                  </l-image-dialog>
                </v-flex>
                <v-flex xs12>
                  <l-select-file
                    @input="addFile(arguments[0], addVehicleInfo.coImage)"
                    file-type="image/*"
                    title="添加图片"
                  >
                    <v-btn color="primary" flat slot="activator" :disabled="addVehicleInfo.coImage.length===1">
                      上传合作图片<span class="error&#45;&#45;text caption" >（至多只上传一张图片）</span>
                    </v-btn>
                  </l-select-file>
                </v-flex>
              </v-layout>
              <v-subheader>添加规则</v-subheader>
              <v-layout column>
                <l-pass-rule-list
                  :pass-rules="addVehicleInfo.passRules"
                  prefix-text="时段"
                >
                  <template slot="action" slot-scope="{item, index}">
                    <div @click.stop>
                      <v-menu left>
                        <v-btn slot="activator" icon small>
                          <v-icon :color="'grey darken-3'" small>{{$vuetify.icons.more}}
                          </v-icon>
                        </v-btn>
                        <v-list dense>
                          <v-list-tile
                            @click="setRuleDialog={activate: true, status: 'edit',item: item, index: index}">
                            <v-list-tile-title class="pr-1">
                              <v-icon small class="pr-3">{{$vuetify.icons.edit}}</v-icon>
                              编辑
                            </v-list-tile-title>
                          </v-list-tile>
                          <v-list-tile
                            @click="deletePassRule(index)">
                            <v-list-tile-title class="pr-1">
                              <v-icon small class="pr-3">{{$vuetify.icons.delete}}</v-icon>
                              删除
                            </v-list-tile-title>
                          </v-list-tile>
                        </v-list>
                      </v-menu>
                    </div>
                  </template>
                </l-pass-rule-list>
                <v-flex xs12>
                  <v-btn
                    flat
                    class="mx-0"
                    color="primary"
                    :disabled="addVehicleInfo.passRules.length===1"
                    @click="
                      setRuleDialog ={
                            activate: true,
                            status: 'new',
                            item: createPassRule(),
                            index: addVehicleInfo.passRules.length
                     }">添加规则</v-btn>
                </v-flex>
                <v-dialog scrollable persistent v-model="setRuleDialog.activate" max-width="900px">
                  <set-pass-rule-content
                    :authority="auth"
                    v-if="setRuleDialog.activate"
                    :status="setRuleDialog.status"
                    :rule="setRuleDialog.item"
                    :params="{index: setRuleDialog.index}"
                    @cancel="setRuleDialog.activate=false"
                    @save="setPassRule"
                  ></set-pass-rule-content>
                  <v-divider></v-divider>
                </v-dialog>
              </v-layout>
              <v-subheader>添加车辆</v-subheader>
              <v-layout v-for="(v,index) in addVehicleInfo.vehicleInfo" :key="index" v-if="addVehicleInfo.vehicleInfo.length!==0" class="pl-4" column>
                <v-layout>
                  <v-flex xs6 class="pt-5">
                    <l-plate-picker v-model="v.plate" :rules="[$rules.requiredS()]"></l-plate-picker>
                  </v-flex>
                  <v-layout column xs6 class="pl-4">
                    <v-flex xs12>
                      <l-image v-if="v.image.length === 0"></l-image>
                      <l-image-dialog
                        :src="img.src"
                        v-for="(img,i) in v.image" :key="i">
                        <l-image
                          slot="activator"
                          :src="img.src"
                          :error="img.error"
                          :errorMessage="img.errorMessage"
                        >
                          <template slot="action">
                            <v-tooltip bottom>
                              <span>删除图像</span>
                              <v-btn slot="activator" @click="deleteImage(v.image, i)" icon>
                                <v-icon>$vuetify.icons.delete</v-icon>
                              </v-btn>
                            </v-tooltip>
                          </template>
                        </l-image>
                      </l-image-dialog>
                    </v-flex>
                    <v-flex xs12>
                      <l-select-file
                        @input="addFile(arguments[0], v.image)"
                        file-type="image/*"
                        title="添加图片"
                      >
                        <v-btn color="primary" flat slot="activator" :disabled="v.image.length===1">
                          上传行驶证<span class="error&#45;&#45;text caption" >（至多只上传一张图片）</span>
                        </v-btn>
                      </l-select-file>
                    </v-flex>
                  </v-layout>
                </v-layout>
                <v-divider></v-divider>
              </v-layout>
              <v-layout justify-center>
                <v-btn icon @click="addVehicleItem">
                  <v-icon color="primary">{{$vuetify.icons.add}}</v-icon>
                </v-btn>
              </v-layout>
            </v-layout>
          </v-form>
          </v-card-text>
          <v-card-actions>
            <v-layout justify-center>
              <v-btn class="primary" @click="submitAddVehicle" :laoding="addVehicleInfo.loading">提交</v-btn>
            </v-layout>
          </v-card-actions>
        </v-card>
    </v-dialog>
    <v-dialog v-model="addAdminInfo.activated" width="800">
      <v-layout column>
        <v-card class="pa-3">
          <v-card-title>
            添加单位管理员
          </v-card-title>
          <v-layout column>
            <v-layout>
              <v-flex xs12 class="pl-2">
                <v-autocomplete
                  :items="extraInfo.groupUserSelect"
                  v-model="extraInfo.admin"
                  v-on:keyup="getGroupUsers"
                  label="单位管理员配置"
                  clearable
                  hide-details
                  hide-selected
                  item-text="name"
                  item-value="id"
                  return-object
                  prepend-icon="mdi-account"
                >
                  <template slot="no-data">
                    <v-alert :value="true" color="error">
                      暂无用户信息
                    </v-alert>
                  </template>
                  <template slot="item" slot-scope="props">
                    <v-list-tile-content>
                      <v-list-tile-title>
                        <v-flex row align-center justify-between>
                          <span>{{props.item.name}}</span>
                        </v-flex>
                      </v-list-tile-title>
                    </v-list-tile-content>
                    <v-list-tile-action>
                      <span class="grey--text caption text-xs-right">{{props.item.loginId}}</span>
                    </v-list-tile-action>
                  </template>
                </v-autocomplete>
              </v-flex>
            </v-layout>
            <v-layout>
              <v-radio-group mandatory row v-model="addAdminInfo.type" label="管理类型" prepend-icon="$vuetify.icons.lock" class="pl-2">
                <v-radio :value="'vehicle'" label="车行管理"></v-radio>
                <v-radio :value="'person'" label="人行管理"></v-radio>
                <v-radio :value="'all'" label="人行&车行管理"></v-radio>
              </v-radio-group>
            </v-layout>
            <v-layout justify-center>
              <v-btn class="primary" @click="addAdmin">确定</v-btn>
              <v-btn class="error" @click="addAdminInfo.activated=false">取消</v-btn>
            </v-layout>
          </v-layout>
        </v-card>
      </v-layout>
    </v-dialog>
  </l-layout>
</template>

<script>
import {time} from '../../../ladmin/utils'
import {Group, PassRule, ReservationAuthority} from '../../../object'
import LPlatePicker from '@/components/LPlatePicker'
import SetPassRuleContent from '../../../components/SetPassRuleContent'
import LPassRuleList from '../../../components/LPassRuleList'
export default {
  name: 'groupContent',
  props: {
    type: {type: String, default: ''},
    group: {type: Object, default: () => (new Group())}
  },
  components: {
    LPlatePicker,
    SetPassRuleContent,
    LPassRuleList
  },
  data: () => ({
    reservationType:'vehicle',
    hasOrgConfig:false,
    hasPersonConfig:false,
    showUser: false,
    roleHeaders: [
      {text: '角色名称', value: 'name', align: 'left', placeholder: 'N/A'},
      {text: '角色描述', value: 'description', align: 'right', placeholder: 'N/A'},
      {text: '上次修改', value: 'lastEditor', align: 'right', placeholder: 'N/A'},
      {text: '创建时间', value: 'creationTime', align: 'right', placeholder: 'N/A', f: v => time.stringify(v)},
    ],
    userHeaders: [
      {text: '用户姓名', value: 'name', align: 'left', placeholder: 'N/A'},
      {text: '用户账号', value: 'loginId', align: 'right', placeholder: 'N/A'},
      {text: '上次修改', value: 'lastEditor', align: 'right', placeholder: 'N/A'},
      {text: '创建时间', value: 'creationTime', align: 'right', placeholder: 'N/A', f: v => time.stringify(v)},
    ],
    tab: 0,
    addAdminInfo:{
      activated:false,
      type:'vehicle'
    },
    userType:'vehicle',
    extraInfo: {
      admin: '',
      adminSelect: [],
      vehicle: '',
      vehicleSelect: [],
      groupUserSelect: [],
      adminHeader: [
        {text: '管理员姓名', value: 'name', align: 'left', sortable: false},
        {text: '管理员ID', value: 'loginId', align: 'left'},
        {text: '管理类型', value: 'type', align: 'left',f:(v)=>(v==='vehicle'?"车行管理":(v==='all')?"人行管理&车行管理":"人行管理")},
        {text: '', value: '', sortable: false}
      ],
      vehicleHeader: [
        {text: '合同名', value: 'domain', align: 'left', placeholder: 'N/A'},
        {text: '车牌号', value: 'code', align: 'left'},
        {text: '', value: '', sortable: false}
      ],
      showDrivers: false,
      showAdmins: false,
      showVehicles: false
    },
    addVehicleInfo: {
      activate: false,
      vehicleInfo: [],
      passRules: [],
      isCo: false,
      coName: '',
      coImage: [],
      loading: false,
      status: 'new',
      index: 0,
      referIdSlot: ''
    },
    /* 通行规则配置相关使用参数 */
    setRuleDialog: {
      activate: false,
      status: 'new',
      item: {},
      index: 0,
    },
    ownerId: '',
  }),
  computed: {
    controllerList () {
      return this.$store.state.parkingLot.controllerList
    },
    isOrg () {
      return this.type === Group.ORGANIZATION
    },
    typeName () {
      if (this.isOrg) {
        return '单位'
      }
      else {
        return '分组'
      }
    },
    auth () {
      let auth = this.$store.state.reservation.adminAuth
      auth.editPrompt = false
      return auth
      /* new ReservationAuthority({
        name: '合作用户规则',
        maxVehicleAmount: 1000,
        maxStartDay: 30,
        maxDurationDay: 30
      }) */
    },
  },
  created () {
    this.getReservationOrgConfig()
    this.getReservationPersonConfig()
    this.getReservationConfig()
    this.ownerId = this.$route.query.id
    if (this.type === 'org') {
      this.getExtraConfig()
    }
  },
  methods: {
    getExtraConfig () {
      this.getAdmins()
      this.getVehicles()
    },
    getBindUsers (params, group) {
      // console.log(params)
      return this.$store.dispatch('userAdmin/getUsersByGroup', {params, group})
    },
    goEdit () {
      this.$store.dispatch('L/routerInTab').then(() => {
        this.$router.replace({
          name: this.isOrg ? 'EditOrg' : 'EditGroup',
          params: this.$route.params,
          query: this.$route.query
        })
      })
    },
    async getGroupUsers (data) {
      let search = (data === undefined) ? '' : data.target.value
      let pagination = {page: 0, rowsPerPage: 10}
      let param = {
        'searchParam': {
          'name': {
            'index': '1',
            'order': 'DESC',
            'operators': [
              {
                'keyword': search,
                'operator': 'LIKE',
                'matchType': 'BOTH'
              }
            ]
          }
        }
      }
      let res = await this.$store.dispatch('reservationConfig/getGroupUsers', {param: param, pagination: pagination, id: this.ownerId})
      if (res.data.status === 1) {
        // alert(1)
        // console.log(res)
        this.extraInfo.groupUserSelect = res.data.data.content
        console.log(this.extraInfo.groupUserSelect)
      }
      else {
        this.extraInfo.groupUserSelect = []
      }
    },
    addAdmin () {
      if (this.extraInfo.admin === '') {
        this.$L.alert('error', {message: '添加管理员不能为空'})
        return
      }
      let vehicle_ids = []
      let person_ids = []
      for (let n in this.extraInfo.adminSelect) {
        let extend = {
          name: this.extraInfo.adminSelect[n].name,
          loginId: this.extraInfo.adminSelect[n].loginId,
        }
        let obj = {
          code: this.extraInfo.adminSelect[n].code,
          files: '',
          domain: '',
          domainFileExtend: '',
          referIdSlot: '',
          extend: JSON.stringify(extend),
        }
        if(this.extraInfo.adminSelect[n].type==='vehicle'){
          vehicle_ids.push(obj)
        }
        else if(this.extraInfo.adminSelect[n].type==='person'){
          person_ids.push(obj)
        }else{
          vehicle_ids.push(obj)
          person_ids.push(obj)
        }
      }
      let extend = {
        name: this.extraInfo.admin.name,
        loginId: this.extraInfo.admin.loginId
      }
      let obj = {
        code: this.extraInfo.admin.id,
        files: '',
        domain: '',
        domainFileExtend: '',
        referIdSlot: '',
        extend: JSON.stringify(extend),
      }
      if(this.addAdminInfo.type === 'vehicle'){
        vehicle_ids.push(obj)
      }else if(this.addAdminInfo.type === 'person'){
        person_ids.push(obj)
      }else{
        vehicle_ids.push(obj)
        person_ids.push(obj)
      }
      this.extraInfo.admin = ''
      this.updateAdmin(vehicle_ids,person_ids)
    },
    async updateAdmin (vehicle_ids,person_ids) {
      let vehicle_res = await this.$store.dispatch('vehicleRegister/addExtraConfig', {id: this.ownerId, type: 'admin', ids: vehicle_ids,userType:'vehicle'})
      let person_res = await this.$store.dispatch('vehicleRegister/addExtraConfig', {id: this.ownerId, type: 'admin', ids: person_ids,userType:'person'})
      if (vehicle_res.data.status === 1&&person_res.data.status===1) {
        this.$L.alert('success', {message: '更新成功'})
        this.getAdmins()
      }
      else {
        if(vehicle_res.data.status !== 1){
          this.$L.alert('error', {message: vehicle_res.data.msg})
        }
        else{
          this.$L.alert('error', {message: person_res.data.msg})
        }
      }
    },
    async getAdmins () {
      let res1 = await this.$store.dispatch('vehicleRegister/getExtraConfig', {id: this.ownerId, type: 'admin',userType:'vehicle'})
      let res2 = await this.$store.dispatch('vehicleRegister/getExtraConfig', {id: this.ownerId, type: 'admin',userType:'person'})
      this.addAdminInfo.activated = false
      if (res1.data.status === 1) {
        if (res1.data.data === '[]') {
          return
        }
        this.extraInfo.adminSelect = []
        let array = JSON.parse(res1.data.data)
        array = array.configs
        for (let i = 0; i < array.length; i++) {
          let item = array[i]
          if (item.extend !== '') {
            item.name = JSON.parse(item.extend).name || ''
            item.loginId = JSON.parse(item.extend).loginId || ''
            item.type = 'vehicle'
          }
          this.extraInfo.adminSelect.push(item)
        }
        // console.log(this.extraInfo.adminSelect)
      }
      else {
        this.extraInfo.adminSelect = []
        //this.$L.alert('error', {message: '获取单位管理员列表失败，原因：' + res1.data.msg})
      }
      if (res2.data.status === 1) {
        if (res2.data.data === '[]') {
          return
        }
        let array = JSON.parse(res2.data.data)
        array = array.configs
        for (let i = 0; i < array.length; i++) {
          let item = array[i]
          if (item.extend !== '') {
            item.name = JSON.parse(item.extend).name || ''
            item.loginId = JSON.parse(item.extend).loginId || ''
            item.type = 'person'
          }
          let flag = false
          for(let j=0;j<this.extraInfo.adminSelect.length;j++){
            if(item.loginId === this.extraInfo.adminSelect[j].loginId){
              this.extraInfo.adminSelect[j].type = 'all'
              flag = true
            }
          }
          if(!flag){
            this.extraInfo.adminSelect.push(item)
          }
        }
        // console.log(this.extraInfo.adminSelect)
      }
      else {
        return
        //this.$L.alert('error', {message: '获取单位管理员列表失败，原因：' + res1.data.msg})
      }
    },
    async deleteAdminConfirm(item){
      let {res, close} = await this.$L.confirm({
        title: '确认删除该单位管理员？',
        text: '管理员名称:' + item.name
      })
      if (res) {
        try {
          await this.deleteAdmin(item)
        }
        catch (e) {
          this.$L.alert('error', e.message)
        }
      }
      close()
    },
    deleteAdmin (item) {
      let index
      for (let i = 0; i < this.extraInfo.adminSelect.length; i++) {
        if (this.extraInfo.adminSelect[i].code === item.code) {
          index = i
          break
        }
      }
      // console.log(this.extraInfo.adminSelect)
      this.extraInfo.adminSelect.splice(index, 1)
      let vehicle_ids = []
      let person_ids = []
      for (let n in this.extraInfo.adminSelect) {
        let extend = {
          name: this.extraInfo.adminSelect[n].name,
          loginId: this.extraInfo.adminSelect[n].loginId,
        }
        let obj = 	{
          code: this.extraInfo.adminSelect[n].code,
          files: '',
          domain: '',
          domainFileExtend: '',
          referIdSlot: '',
          extend: JSON.stringify(extend),
        }
        if(this.extraInfo.adminSelect[n].type==='vehicle'){
          vehicle_ids.push(obj)
        }else if(this.extraInfo.adminSelect[n] === 'person'){
          person_ids.push(obj)
        }else{
          vehicle_ids.push(obj)
          person_ids.push(obj)
        }
      }
      this.updateAdmin(vehicle_ids,person_ids)
    },
    addVehicle () {
      this.resetAddVehicleInfo()
      this.addVehicleInfo.activate = true
    },
    addVehicleItem () {
      this.addVehicleInfo.vehicleInfo.push({
        plate: '',
        image: []
      })
    },
    editAddVehicle (item) {
      console.log(item)
      this.resetAddVehicleInfo()
      this.addVehicleInfo.coName = item.domain
      let domianImage = new Image()
      if (item.domainFileExtend !== '') {
        let domianImageJson = JSON.parse(item.domainFileExtend)
        if (domianImageJson.pic[2].url3 !== '') {
          domianImage.url = domianImageJson.pic[2].url3
          this.getImg(domianImage)
          this.addVehicleInfo.coImage.push(domianImage)
        }
      }
      this.addVehicleItem()
      let vehicleImage = new Image()
      let vehicleImageJson = JSON.parse(item.files)
      if (vehicleImageJson.pic[1].url2 !== '') {
        vehicleImage.url = vehicleImageJson.pic[1].url2
        this.getImg(vehicleImage)
      }
      this.addVehicleInfo.vehicleInfo[0].plate = item.code
      this.addVehicleInfo.vehicleInfo[0].image.push(vehicleImage)
      let rule = JSON.parse(item.extend).rule
      rule = JSON.parse(rule)
      this.addVehicleInfo.passRules.push(PassRule.fromAPI(rule[0], this.controllerList))
      this.addVehicleInfo.passRules.forEach(function (r) {
        r.audioPromptIn = false
        r.audioPromptOut = false
        r.ledPromptIn = false
        r.ledPromptOut = false
      })
      this.addVehicleInfo.activate = true
      if (this.addVehicleInfo.coImage.length !== 0) {
        this.addVehicleInfo.isCo = true
      }
      this.addVehicleInfo.status = 'edit'
      for (let i = 0; i < this.extraInfo.vehicleSelect.length; i++) {
        if (item.code === this.extraInfo.vehicleSelect[i].code) {
          this.addVehicleInfo.index = i
          break
        }
      }
    },
    goToPassGroup () {
      this.$router.push({
        name: 'passGroupDetails',
        params: {id: this.addVehicleInfo.referIdSlot},
        query: {id: this.addVehicleInfo.referIdSlot}
      })
    },
    submitAddVehicle () {
      if (!this.checkAddVehicle()) {
        return
      }
      let configs = []
      for (let i = 0; i < this.addVehicleInfo.vehicleInfo.length; i++) {
        let item = this.addVehicleInfo.vehicleInfo[i]
        let files = {
          pic: [
            {name: '驾驶证', url1: ''},
            {name: '行驶证', url2: item.image[0].url},
            {name: '其他证明', url3: ''}
          ],
          msg: ''
        }
        let domainFileExtend = {
          pic: [
            {name: '驾驶证', url1: ''},
            {name: '行驶证', url2: item.image.url || ''},
            {name: '其他证明', url3: this.addVehicleInfo.coImage.length === 0 ? '' : this.addVehicleInfo.coImage[0].url}
          ],
          msg: ''
        }
        let ruleArr = []
        ruleArr.push(this.addVehicleInfo.passRules[0].toAPI())
        let extend = {
          rule: JSON.stringify(ruleArr)
        }
        let vehicle = {
          code: item.plate,
          files: JSON.stringify(files),
          domain: this.addVehicleInfo.coName,
          domainFileExtend: (this.addVehicleInfo.isCo) ? JSON.stringify(domainFileExtend) : '',
          referIdSlot: '',
          extend: JSON.stringify(extend),
        }
        configs.push(vehicle)
      }
      if (this.addVehicleInfo.status === 'edit') {
        this.extraInfo.vehicleSelect.splice(this.addVehicleInfo.index, 1)
      }
      for (let i = 0; i < this.extraInfo.vehicleSelect.length; i++) {
        configs.push(this.extraInfo.vehicleSelect[i])
      }
      this.updateVehicle(configs)
    },
    resetAddVehicleInfo () {
      this.addVehicleInfo.activate = false
      this.addVehicleInfo.isCo = false
      this.addVehicleInfo.coName = ''
      this.addVehicleInfo.coImage = []
      this.addVehicleInfo.passRules = []
      this.addVehicleInfo.vehicleInfo = []
      this.addVehicleInfo.status = 'new'
    },
    checkAddVehicle () {
      if (this.addVehicleInfo.passRules.length === 0) {
        this.$L.alert('error', {message: '请先配置通行规则'})
        return false
      }
      if (this.addVehicleInfo.vehicleInfo.length === 0) {
        this.$L.alert('error', {message: '请添加车辆'})
        return false
      }
      if (this.addVehicleInfo.isCo && this.addVehicleInfo.coImage.length === 0) {
        this.$L.alert('error', {message: '请上传合作证明'})
        return false
      }
      if (!this.$refs.addVehicleForm.validate()) {
        this.$L.alert('error', {message: '表单数据错误'})
        return false
      }
      return true
    },
    async updateVehicle (ids) {
      this.addVehicleInfo.loading = true
      let res = await this.$store.dispatch('vehicleRegister/addExtraConfig', {id: this.ownerId, type: 'vehicle', ids: ids,userType:this.userType})
      this.addVehicleInfo.loading = false
      if (res.data.status === 1) {
        this.$L.alert('success', {message: '更新成功'})
        this.resetAddVehicleInfo()
        this.getVehicles()
      }
      else {
        this.$L.alert('error', {message: res.data.msg})
      }
    },
    async getVehicles () {
      let res1 = await this.$store.dispatch('vehicleRegister/getExtraConfig', {id: this.ownerId, type: 'vehicle',userType:this.userType})
      if (res1.data.status === 1) {
        if (res1.data.data === '[]') {
          return
        }
        this.extraInfo.vehicleSelect = []
        let data = JSON.parse(res1.data.data)
        let referIdSlot = data.referIdSlot
        if (referIdSlot !== '') {
          this.addVehicleInfo.referIdSlot = referIdSlot
        }
        let array = data.configs
        for (var i = 0; i < array.length; i++) {
          let item = array[i]
          this.extraInfo.vehicleSelect.push(item)
        }
      }
      else {
        // this.$L.alert('error', {message: '获取驾驶员列表失败，原因：' + res1.data.msg})
      }
    },
    async deleteVehicleConfirm(item){
      let {res, close} = await this.$L.confirm({
        title: '确认删除该车辆？',
        text: '车牌号码:' + item.code
      })
      if (res) {
        try {
          await this.deleteVehicle(item)
        }
        catch (e) {
          this.$L.alert('error', e.message)
        }
      }
      close()
    },
    deleteVehicle (item) {
      let index
      for (let i = 0; i < this.extraInfo.vehicleSelect.length; i++) {
        if (this.extraInfo.vehicleSelect[i].code === item.code) {
          index = i
          break
        }
      }
      this.extraInfo.vehicleSelect.splice(index, 1)
      let ids = []
      for (let n in this.extraInfo.vehicleSelect) {
        ids.push(this.extraInfo.vehicleSelect[n])
      }
      this.updateVehicle(ids)
    },
    createPassRule () {
      return new PassRule()
    },
    /* set通行规则 */
    setPassRule (res) {
      this.setRuleDialog.activate = false
      let {status, newItem, oldItem} = res
      if (status === 'new') {
        newItem.audioPromptIn = false
        newItem.audioPromptOut = false
        newItem.ledPromptIn = false
        newItem.ledPromptOut = false
        this.addVehicleInfo.passRules.push(newItem)
      }
      else if (status === 'edit') {
        newItem.audioPromptIn = false
        newItem.audioPromptOut = false
        newItem.ledPromptIn = false
        newItem.ledPromptOut = false
        this.addVehicleInfo.passRules[this.setRuleDialog.index] = newItem
      }
    },
    /* 删除通行规则 */
    deletePassRule (index) {
      this.addVehicleInfo.passRules.splice(index, 1)
    },
    async getReservationConfig () {
      let res = await this.$store.dispatch('reservationConfig/getReservationConfig', 'admin')
      // console.log(res.data.data)
      if (res.data.status === 1) {
        let object = new ReservationAuthority({
          name: '高级预约',
          maxVehicleAmount: 1000,
          maxStartDay: -1,
          maxDurationDay: res.data.data.maxDurDays,
          presetCtrls: res.data.data.presetCtrls,
          type: ['sectional', 'day', 'week'],

          // 是否可以定义分组名称和描述
          editGroupInfo: true,

          // 是否可定义特殊进出场提示
          editPrompt: true
        })
        // console.log(object)
        this.$store.commit('reservation/setAdminAuth', object)
      }
      else {
        this.$L.alert('error', {message: '查询预约配置失败，原因：' + res.data.msg})
      }
    },
    async addFile (file, target) {
      // file 实际上为fileList
      let imageCheckType = ['jpg', 'jpeg', 'png', 'gif']
      let IMAGE_MAX_SIZE = 5 * 1000 * 1000
      for (let f of file) {
        let checkType = imageCheckType
        let maxSize = IMAGE_MAX_SIZE
        // console.log('get file', f)
        let suffix = /\.([^.]*)$/i.exec(f.name)[1]
        if (checkType.indexOf(suffix) === -1) {
          this.$L.error({
            title: '上传文件格式错误',
            message: `上传格式: ${suffix}, 支持的格式: ${checkType.join(',')}`
          })
          return
        }
        else if (f.size > maxSize) {
          this.$L.error({
            title: '文件容量过大',
            message: `文件大小: ${Math.round(f.size / 1000)}KB, 最大限制: ${Math.round(maxSize / 1000)}KB`
          })
          return
        }
      }

      let temp = new Image()
      temp.loading = true
      if (target instanceof Array) {
        target.push(temp)
        // 上传图片
        let img = await this.uploadFile(file)
        this.$set(target, target.length - 1, img)
        // console.log(this.vehicleForm.driverLicense)
        this.getImg(img)
      }
    },
    deleteImage (target, i) {
      target.splice(i, 1)
    },
    async uploadFile (files) {
      if (files instanceof Object && files.length > 0) {
        let file = files[0]
        let img = new Image()
        // console.log(img)
        try {
          let res = await this.$store.dispatch('uploadFile', {file, url: '/passApi/check/file'})
          img.url = res
        }
        catch (e) {
          img.error = true
          img.errorMessage = e.message
        }
        return img
      }
    },
    async getImg (img) {
      // console.log(img)
      img.loading = true
      let path = img.url
      this.$set(img, 'src', 'https://smaco2.uestc.edu.cn/passApi' + path)
      img.loading = false
    },
    async getReservationOrgConfig(){
      let filter = [
        {key:'ownerType',value:'group'},
        {key:'orderType',value:'order_group'},
        {key:'ownerId',value:this.group.id}
      ]
      let pagination = {
        page:1,
        rowsPerPage: 10
      }
      let res = null
      if(this.reservationType==='vehicle'){
        res = await this.$store.dispatch('reservationConfig/getConfigListNew',{pagination:pagination,filter:filter})
      }
      if(res.items.length===0){
        this.hasOrgConfig = false
      }else{
        this.hasOrgConfig = true
      }
    },
    async getReservationPersonConfig(){
      let filter = [
        {key:'ownerType',value:'group'},
        {key:'orderType',value:'order_object'},
        {key:'ownerId',value:this.group.id}
      ]
      let pagination = {
        page:1,
        rowsPerPage: 10
      }
      let res = null
      if(this.reservationType==='vehicle'){
        res = await this.$store.dispatch('reservationConfig/getConfigListNew',{pagination:pagination,filter:filter})
      }
      if(res.items.length===0){
        this.hasPersonConfig = false
      }else{
        this.hasPersonConfig = true
      }
    },
    createOrgConfig(){
      if(this.reservationType==='vehicle'){
        this.$router.push({
          name: 'NewPersonalGroupConfig',
          query: {
            ownerId: this.group.id,
            orderType: 'order_group',
            status: 'new',
            ownerType: 'group',
          }
        })
      }else{
        this.$router.push({
          name: 'PersonNewPersonalGroupConfig',
          query: {
            ownerId: this.group.id,
            orderType: 'order_group',
            status: 'new',
            ownerType: 'group',
          }
        })
      }
    },
    createPersonConfig(){
      if(this.reservationType==='vehicle'){
        this.$router.push({
          name: 'NewPersonalGroupConfig',
          query: {
            ownerId: this.group.id,
            orderType: 'order_object',
            status: 'new',
            ownerType: 'group',
          }
        })
      }else{
        this.$router.push({
          name: 'PersonNewPersonalGroupConfig',
          query: {
            ownerId: this.group.id,
            orderType: 'order_object',
            status: 'new',
            ownerType: 'group',
          }
        })
      }
    },
    goOrgConfig(){
      if(this.reservationType==='vehicle'){
        this.$router.push({
          name: 'ConfigDetail',
          query: {
            ownerId: this.group.id,
            orderType: 'order_group',
            status: 'readonly',
            ownerType: 'group'
          }
        })
      }else{
        this.$router.push({
          name: 'PersonConfigDetail',
          query: {
            ownerId: this.group.id,
            orderType: 'order_group',
            status: 'readonly',
            ownerType: 'group'
          }
        })
      }
    },
    goPersonConfig(){
      if(this.reservationType==='vehicle'){
        this.$router.push({
          name: 'ConfigDetail',
          query: {
            ownerId: this.group.id,
            orderType: 'order_object',
            status: 'readonly',
            ownerType: 'group'
          }
        })
      }else{
        this.$router.push({
          name: 'PersonConfigDetail',
          query: {
            ownerId: this.group.id,
            orderType: 'order_object',
            status: 'readonly',
            ownerType: 'group'
          }
        })
      }
    }
  },
  watch:{
    userType(){
      this.getExtraConfig()
    },
    reservationType(){
      this.getReservationOrgConfig()
      this.getReservationPersonConfig()
    }
  }
}
</script>

<style scoped>

</style>
